import React, {useState} from 'react';
import {Button, Modal, ModalBody, ModalFooter} from 'reactstrap';
import {CornerDownRightIcon} from 'lucide-react';
import Gallery from './Gallery.tsx';
import {MixModel} from '../../api/types.ts';
import Icon from '../shared/Icon.tsx';
import ChooseProjectTabModal from '../canvas/ChooseProjectTabModal.tsx';
import {ProjectCardTarget} from '../canvas/projectCard.ts';

interface SelectProjectModalProps {
    onClose: () => void;
    onProjectSelected: (mix: MixModel, target?: ProjectCardTarget) => void;
    myProjects?: boolean;
    /*
     * Asks which tab to open after a project is picked, and offers the
     * project you are in, so a link can go to one of its own tabs.
     */
    chooseTab?: boolean;
    currentProjectId?: string;
}

const SelectProjectModal: React.FC<SelectProjectModalProps> = ({
    onClose,
    onProjectSelected,
    myProjects,
    chooseTab,
    currentProjectId
}) => {
    const [pickedRef, setPickedRef] = useState<string | null>(null);

    if (chooseTab && pickedRef) {
        return (
            <ChooseProjectTabModal
                projectRef={pickedRef}
                onBack={() => setPickedRef(null)}
                onClose={onClose}
                onChosen={onProjectSelected}
            />
        );
    }

    const onProjectClick = (mix: MixModel) => {
        if (!mix.id) {
            return;
        }
        if (chooseTab) {
            setPickedRef(mix.id);
        } else {
            onProjectSelected(mix);
        }
    };

    return (
        <Modal toggle={() => onClose()} isOpen fullscreen>
            <ModalBody>
                {chooseTab && currentProjectId && (
                    <div className="row mb-3">
                        <div className="col-12">
                            <Button
                                color="secondary"
                                className="btn-icon"
                                onClick={() => setPickedRef(currentProjectId)}
                            >
                                <Icon icon={CornerDownRightIcon} />
                                Link to a tab in this project
                            </Button>
                        </div>
                    </div>
                )}
                <div className="row">
                    <div className="col-12">
                        <Gallery
                            myProjects={myProjects ?? false}
                            onProjectClick={onProjectClick}
                            options={{
                                disableSwitchMixType: true,
                                transientState: true
                            }}
                        />
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={() => onClose()}>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default SelectProjectModal;
